module.exports = __webpack_public_path__ + "img/fondo.9e1be9cf.jpg";